// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__lP779","big":"Spinner_big__2C_ho","small":"Spinner_small__2lgrX"};